const flatten = (input) => input.reduce((a, b) => [...a, ...b], []);

export default flatten;
